export default __webpack_public_path__ + "static/media/sec2.6030abb2.svg";